import trame from '../../media/trame.webp';
import IsRoot from "../IsRoot";

function HeaderICFF() {
  // console.log("trameError")
  // console.log(trame)
  // console.log("")
  let trameRef = trame;
  if( IsRoot() ){ // is root link modifications
    trameRef = "." + trame // adding this goes up one Dir level :)
  }

  return (
    <div className="logoHeader">
      <div className="trame-logo">
        <img  className="trame-img" src={trameRef} alt="trame Logo" />
      </div>
      <p className="AL-txt">Enlace by Aranda\Lasch</p>
    </div>
  );
}

export default HeaderICFF;